var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMegaphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.08823 13.5487C2.83036 13.5487 1 11.7229 1 9.47068C1 7.21846 2.83036 5.39267 5.08823 5.39267H6.437M5.08823 13.5487C5.08823 13.5487 6.5 18.4396 7 19.9345C7.5 21.4293 10 21.4293 10 19.4362C10 17.4431 10 16.349 10 13.8088M5.08823 13.5487H6.437M10 13.8088C12.8477 14.4575 15.4867 16.1862 18.0258 17.4526C23.1139 19.9902 22.9998 11.9421 22.9998 9.47068C22.9998 6.99924 23.1139 -1.04887 18.0258 1.48881C14.8411 3.07716 11.4994 5.39267 7.78577 5.39267H6.437M10 13.8088C9.27601 13.6438 8.53853 13.5487 7.78577 13.5487H6.437M6.437 13.5487V5.39267",
    stroke: "#FBFDFC",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 7V12",
    stroke: "#FBFDFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/Megaphone.e74187280bd7c9a7aa8b04782f763626.svg";
export { ForwardRef as ReactComponent };